import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-third-parties-navigation',
  templateUrl: 'third-parties-navigation.component.html',
  imports: [MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class ThirdPartiesNavigationComponent {
  routeUrl$: Observable<string> = this.store.select(RouterSelectors.getPath);
  isNedap$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('nedap') > 0));
  isLeeO$: Observable<boolean> = this.routeUrl$.pipe(map((url) => url.indexOf('leeo') > 0));

  constructor(private readonly store: Store<RootState>) {}
}
